import { debounce } from "debounce-decorator";
import { seamlessApi } from "../../../helpers";
export const mobileScrollHandling = (function () {
    let Y, dY;
    function touchStartHandler(e) {
        Y = e.changedTouches[0].clientY;
    }
    function touchMoveHandler(e) {
        dY = e.changedTouches[0].clientY - Y;
        if ((dY > 0 && this.scrollTop === 0) || (dY < 0 && this.scrollHeight - this.scrollTop === this.clientHeight)) {
            preventScroll(e);
            return false;
        }
        return true;
    }
    function preventScroll(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    return {
        touchStartHandler,
        touchMoveHandler,
        preventScroll
    };
})();
/* istanbul ignore next */
export const desktopScrollHandling = {
    handler(e) {
        e.preventDefault();
        e.stopPropagation();
        window.scrollTo(desktopScrollHandling.scrollValX, desktopScrollHandling.scrollValY);
        return false;
    },
    scrollValX: 0,
    scrollValY: 0,
    setScrollVals() {
        this.scrollValX = window.pageXOffset;
        this.scrollValY = window.pageYOffset;
    }
};
export function setContentTopPosition() {
    //When in iframe with Seamless API
    if (this.isInIframe) {
        if (this.deviceDetect.isDesktop) {
            this.setContentElTop(300);
            seamlessApi.operator.scrollToTop();
        }
        else {
            this.setContentElTop(200);
            seamlessApi.operator.scrollToTop();
        }
    }
    else {
        if (typeof this.config.offsetTop !== "undefined") {
            const offsetTop = this.config.offsetTop;
            this.setContentElTop(window.pageYOffset + offsetTop);
            //msg.refs.content.style.transform = 'translate(-50%, 0)';
        }
        else {
            const YOffset = document.body.scrollTop > window.pageYOffset ? document.body.scrollTop : window.pageYOffset;
            this.setContentElTop(Math.round(YOffset + (window.innerHeight / 2)));
        }
    }
}
export const setContentTopPositionDebounced = debounce(setContentTopPosition, 50);
//# sourceMappingURL=EventHandlers.js.map